import { useState } from "react";
import Cleave from "cleave.js/react";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import { MyFormData, myAxios, objAscSort, safeParseJson } from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function FilterForm({
    curFilter, 
    setFilter, 
    setProjects, 
    setCurrentPage, 
    defaultFilter, 
    dataFrame, 
    filterWords
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    //--------------------------------------------------------------------------------------------
    const [newFilter, setNewFilter] = useState(curFilter);
    const [showFilter, setShowFilter] = useState(false);
    const closeIt = () => {
        setShowFilter(false);
        setCurrentPage(1);
    }
    //--------------------------------------------------------------------------------------------
    return(
        <>
        <span
            className = "pointer p-1 rounded"
            style = {{
                backgroundColor: Object.entries(curFilter).filter(([key, value]) => defaultFilter[key] !== value).length?
                "rgb(0,123,255)"
                :undefined
            }}
            onClick = {() => setShowFilter(true)}
        >Filter</span>
        {showFilter?
        <Modal
            // touchOutsideClose = {true}
            handleFormSubmit = {async() => {
                const formData = new MyFormData();
                formData.append("btl", filterWords);
                const filter = [];
                Object.entries(newFilter).forEach(([key, value]) => {
                    if(value !== defaultFilter[key]){
                        filter.push([key, value]);
                    }
                });
                formData.append("filter", JSON.stringify(filter));
                //------------------------------
                setShowLoader(true);
                const res = await myAxios("projects/readProjectsByFilter.php", formData);
                setShowLoader(false);
                if(!res) return;
                //------------------------------
                const mainData = res.data.map(project => ({...project, projectFiles: safeParseJson(project.projectFiles)}))
                .sort((a, b) => objAscSort(a, b, "projectCreationDate"));
                setProjects(mainData);
                setCurrentPage(1);
                setFilter(newFilter);
                closeIt();
            }}
            actionKey = {"Search"}
            closeIt = {closeIt}
            title = "Filter"
            width = "800px"
        >
            <div className = "mt-3 mb-3">
                <span className = "btn btn-secondary" onClick = {() => {
                    setNewFilter(defaultFilter);
                    setCurrentPage(1);
                }}>Clear Filter</span>
            </div>
            {dataFrame.map((elem, itemIndex) => 
            <div key = {itemIndex} className = "mb-2 d-flex align-items-center">
                <span className = "font-weight-bold">{elem.title}:</span>
                {["text", "textarea", "email", "file"].includes(elem.type)?
                <input
                    //type = {elem.type}
                    className = "form-control flex-grow-1 ml-3"
                    value = {newFilter[elem.filterKey || elem.key]}
                    onChange = {event => {
                        setNewFilter({...newFilter, [elem.filterKey || elem.key]: event.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                :<></>}
                {elem.type === "phone"?
                <Cleave
                    pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^" 
                    className = "form-control flex-grow-1 ml-3"
                    value = {newFilter[elem.key]}
                    onChange = {event => {
                        setNewFilter({...newFilter, [elem.key]: event.currentTarget.value});
                        setCurrentPage(1);
                    }}
                    options = {{ 
                        blocks:[3, 3, 4],
                        delimiter: "-",
                        numericOnly: true,
                    }}
                />
                :<></>}
                {elem.type === "select"?
                <>
                <input
                    className = "form-control flex-grow-1 ml-3"
                    value = {newFilter[elem.filterKey || elem.key]}
                    onChange = {event => {
                        setNewFilter({
                            ...newFilter,
                            [elem.filterKey || elem.key]: event.currentTarget.value
                        });
                        setCurrentPage(1);
                    }}
                    list = {elem.title + " list"}
                    autoComplete = "off"
                />
                <datalist id = {elem.title + " list"}>
                    {(elem.filterOptions || elem.options)?.map((option, optionIndex) => <option key = {optionIndex} value = {option.value}/>)}
                </datalist>
                </>:<></>}
                {elem.type === "date"?<>
                <>
                    <span className = "ml-3">after:</span>
                    <input
                        type = "date"
                        min = {elem.min || "1900-01-01"}
                        max = {newFilter[elem.key + "Max"] || "2999-12-31"}
                        className = "form-control flex-grow-1 ml-3"
                        value = {newFilter[elem.key + "Min"]}
                        onChange = {event => {
                            setNewFilter({...newFilter, [elem.key + "Min"]: event.currentTarget.value});
                            setCurrentPage(1);
                        }}
                    />
                    <span className = "ml-3">before:</span>
                    <input
                        type = "date"
                        min = {newFilter[elem.key + "Min"] || elem.min || "1900-01-01"}
                        max = {elem.max || "2999-12-31"}
                        className = "form-control flex-grow-1 ml-3"
                        value = {newFilter[elem.key + "Max"]}
                        onChange = {event => {
                            setNewFilter({...newFilter, [elem.key + "Max"]: event.currentTarget.value});
                            setCurrentPage(1);
                        }}
                    />
                </>    
                </>:<></>}
                {elem.type === "number"?<>
                <>
                    <span className = "ml-3">min:</span>
                    <input
                        type = "number"
                        step = {elem.step}
                        min = {elem.min}
                        max = {newFilter[elem.key + "Max"] || elem.max}
                        className = "form-control flex-grow-1 ml-3"
                        value = {newFilter[elem.key + "Min"]}
                        onChange = {event => {
                            setNewFilter({...newFilter, [elem.key + "Min"]: event.currentTarget.value});
                            setCurrentPage(1);
                        }}
                    />
                    <span className = "ml-3">max:</span>
                    <input
                        type = "number"
                        step = {elem.step}
                        min = {newFilter[elem.key + "Min"] || elem.min}
                        max = {elem.max}
                        className = "form-control flex-grow-1 ml-3"
                        value = {newFilter[elem.key + "Max"]}
                        onChange = {event => {
                            setNewFilter({...newFilter, [elem.key + "Max"]: event.currentTarget.value});
                            setCurrentPage(1);
                        }}
                    />
                </>    
                </>:<></>}
                {!["date", "number"].includes(elem.type) && newFilter[elem.filterKey || elem.key] !== defaultFilter[elem.filterKey || elem.key]?
                <span
                    className = "pointer ml-2"
                    onClick = {() => {
                        setNewFilter({
                            ...newFilter, 
                            [elem.filterKey || elem.key]: defaultFilter[elem.filterKey || elem.key]
                        })
                    }}
                >
                    ❌
                </span>
                :<></>}
                {["date", "number"].includes(elem.type) &&
                (newFilter[elem.key + "Max"] !== defaultFilter[elem.key + "Max"] || newFilter[elem.key + "Min"] !== defaultFilter[elem.key + "Min"])?
                <span
                    className = "pointer ml-2"
                    onClick = {() => {
                        setNewFilter({
                            ...newFilter, 
                            [elem.key + "Min"]: defaultFilter[elem.key + "Min"], 
                            [elem.key + "Max"]: defaultFilter[elem.key + "Max"]
                        })
                    }}>
                        ❌
                    </span>
                :<></>}
            </div>
            )}
            <div className = "mt-3 mb-3">
                <span className = "btn btn-secondary" onClick = {() => {
                    setNewFilter(defaultFilter);
                    setCurrentPage(1);
                }}>Clear Filter</span>
            </div>
        </Modal>
        :null}
        </>
    );
}